import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { Container, Spinner } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { gethomedata } from "store/home/actions";

const styles = {
  card: {
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    margin: "0 0 2rem 0",
    overflow: "hidden",
  },
  stepRow: {
    display: "flex",
    gap: "6px",
    padding: "14px 20px 0 20px",
    flexWrap: "wrap",
  },
  stepDone: {
    fontSize: "12px",
    padding: "3px 12px",
    borderRadius: "20px",
    background: "#eaf3de",
    color: "#27500a",
    border: "0.5px solid #c0dd97",
    fontWeight: "500",
  },
  stepActive: {
    fontSize: "12px",
    padding: "3px 12px",
    borderRadius: "20px",
    background: "#e6f1fb",
    color: "#6eb5f8",
    border: "0.5px solid #b5d4f4",
    fontWeight: "500",
  },
  stepIdle: {
    fontSize: "12px",
    padding: "3px 12px",
    borderRadius: "20px",
    background: "#f1f1f1",
    color: "#999",
    border: "0.5px solid #e0e0e0",
  },
  filterRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "12px",
    padding: "14px 20px",
    alignItems: "end",
    borderBottom: "1px solid #eaeaea",
  },
  filterGroup: {
    position: "relative",
    width: "100%",
  },
  filterLabel: {
    display: "block",
    fontSize: "11px",
    fontWeight: "600",
    color: "#667085",
    marginBottom: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.4px",
  },
  filterSelect: {
    width: "100%",
    height: "34px",
    padding: "0 28px 0 10px",
    border: "1px solid #d0d5dd",
    borderRadius: "4px",
    fontSize: "13px",
    color: "#344054",
    background: "#fff",
    appearance: "none",
    cursor: "pointer",
    fontFamily: "inherit",
  },
  filterSelectDisabled: {
    width: "100%",
    height: "34px",
    padding: "0 28px 0 10px",
    border: "1px solid #e8e8e8",
    borderRadius: "4px",
    fontSize: "13px",
    color: "#bbb",
    background: "#fafafa",
    appearance: "none",
    cursor: "not-allowed",
    fontFamily: "inherit",
  },
  chevron: {
    position: "absolute",
    right: "9px",
    top: "67%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "#667085",
    fontSize: "11px",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
  },
  thead: {
    background: "#4fa3f2",
  },
  th: {
    color: "#fff",
    fontWeight: "600",
    fontSize: "13px",
    padding: "11px 16px",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  thLeft: {
    color: "#fff",
    fontWeight: "600",
    fontSize: "13px",
    padding: "11px 16px",
    textAlign: "left",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "12px 16px",
    textAlign: "center",
    color: "#344054",
    borderBottom: "1px solid #f2f2f2",
    fontSize: "14px",
  },
  tdLeft: {
    padding: "12px 16px",
    textAlign: "left",
    color: "#344054",
    borderBottom: "1px solid #f2f2f2",
    fontSize: "14px",
  },
  trEven: { background: "#fff" },
  trOdd: { background: "#f9fbff" },
  emptyState: {
    textAlign: "center",
    padding: "3.5rem 1rem",
    color: "#bbb",
    fontSize: "14px",
  },
  tableNote: {
    fontSize: "12.5px",
    color: "#000000",
    padding: "0 20px 10px 20px",
    lineHeight: "1.5",
    maxWidth: "860px",
  },
};

class CertificatePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      selectedScheme: "",
      selectedCycle: "",
      showResult: false,
      schemeOptions: [],
      cycleOptions: [],
      eligibleSchemeIds: new Set(),
      previousSchemes: {},
      participant_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : null,
      lab_participant_id: null,
    };
  }

  componentDidMount() {
    const { participant_id } = this.state;
    if (participant_id) this.props.gethomedata(participant_id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.home !== this.props.home && this.props.home) {
      const { purchased_schemes, payment_details, participant_id } =
        this.props.home;
      const payments = payment_details?.payments || [];

      const eligibleCycleIds = new Set();
      payments.forEach(p => {
        if (parseFloat(p.discount) === 100 && p.payment_status === "Paid") {
          (p.scheme || "").split(",").forEach(pair => {
            const parts = pair.trim().split("-");
            const cycleId = parts[parts.length - 1];
            if (cycleId) eligibleCycleIds.add(parseInt(cycleId));
          });
        }
      });

      const previousOnly = (purchased_schemes || []).filter(
        s => s.reportstatus === "Previous"
      );

      const previousSchemes = {};
      previousOnly.forEach(s => {
        if (!previousSchemes[s.scheme_id]) {
          previousSchemes[s.scheme_id] = {
            scheme_name: s.scheme_name,
            cycles: [],
          };
        }
        previousSchemes[s.scheme_id].cycles.push({
          cycle_id: s.cycle_id,
          cycle_no: s.cycle_no,
          payment_reconcile_status: s.payment_reconcile_status,
        });
      });

      const schemeOptions = Object.entries(previousSchemes).map(
        ([scheme_id, val]) => ({
          scheme_id: parseInt(scheme_id),
          scheme_name: val.scheme_name,
        })
      );

      const eligibleSchemeIds = new Set();
      (purchased_schemes || []).forEach(s => {
        if (
          s.payment_reconcile_status === "Verified" ||
          eligibleCycleIds.has(s.cycle_id)
        ) {
          eligibleSchemeIds.add(s.scheme_id);
        }
      });

      this.setState({
        schemeOptions,
        previousSchemes,
        eligibleSchemeIds,
        lab_participant_id: participant_id,
        isLoading: false,
      });
    }
  }

  handleSchemeChange = e => {
    const scheme_id = e.target.value ? parseInt(e.target.value) : "";
    const { previousSchemes } = this.state;
    const cycleOptions =
      scheme_id && previousSchemes[scheme_id]
        ? previousSchemes[scheme_id].cycles
        : [];
    this.setState({
      selectedScheme: scheme_id,
      selectedCycle: "",
      cycleOptions,
      showResult: false,
    });
  };

  handleCycleChange = e => {
    this.setState({
      selectedCycle: e.target.value ? parseInt(e.target.value) : "",
      showResult: !!e.target.value,
    });
  };

  handleViewCOP = (scheme_id, cycle_id) => {
    const { lab_participant_id } = this.state;
    const organization_name =
      localStorage.getItem("organization_name") || "default-org";
    const authUser = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser"))
      : null;
    const account_id = authUser?.user_id || "";
    this.props.history.push(
      `/${organization_name}/${lab_participant_id}/certificate?scheme_id=${scheme_id}&cycle_id=${cycle_id}&account_id=${account_id}`
    );
  };

  getStep() {
    const { selectedScheme, selectedCycle } = this.state;
    if (selectedCycle) return 3;
    if (selectedScheme) return 2;
    return 1;
  }

  renderSteps() {
    const step = this.getStep();

    const labels = ["Select Scheme", "Select Cycle", "Done"];
    return (
      <div style={styles.stepRow}>
        {labels.map((label, i) => {
          const num = i + 1;
          const s =
            num < step
              ? styles.stepDone
              : num === step
              ? styles.stepActive
              : styles.stepIdle;
          return (
            <span key={num} style={s}>
              {num}. {label}
            </span>
          );
        })}
      </div>
    );
  }

  buildRows() {
    const {
      selectedScheme,
      selectedCycle,
      schemeOptions,
      cycleOptions,
      eligibleSchemeIds,
    } = this.state;

    const schemeName =
      schemeOptions.find(s => s.scheme_id === selectedScheme)?.scheme_name ||
      "";
    const cycleNo =
      cycleOptions.find(c => c.cycle_id === selectedCycle)?.cycle_no || "";

    return [
      {
        type: "COP",
        schemeName,
        cycleNo,
        eligible: eligibleSchemeIds.has(selectedScheme),
        scheme_id: selectedScheme,
        cycle_id: selectedCycle,
      },
    ];
  }

  renderTable() {
    const { showResult } = this.state;

    if (!showResult) {
      return (
        <div style={styles.emptyState}>
          Select a scheme and cycle to view certificates
        </div>
      );
    }

    const rows = this.buildRows();

    return (
      <>
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead style={styles.thead}>
              <tr>
                <th style={styles.thLeft}>Scheme Name</th>
                <th style={styles.th}>Cycle</th>
                <th style={styles.th}>Certificate Type</th>
                <th style={styles.th}>Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr
                  key={idx}
                  style={idx % 2 === 0 ? styles.trEven : styles.trOdd}
                >
                  <td style={styles.tdLeft}>{row.schemeName}</td>
                  <td style={styles.td}>Cycle {row.cycleNo}</td>
                  <td style={styles.td}>Certificate of Participation (COP)</td>
                  <td style={styles.td}>
                    {row.eligible ? (
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                          color: "#6eb5f8",
                          textDecoration: "underline",
                        }}
                        onClick={() =>
                          this.handleViewCOP(row.scheme_id, row.cycle_id)
                        }
                      >
                        View
                      </span>
                    ) : (
                      <span style={{ color: "#ccc" }}>—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }

  render() {
    const {
      isLoading,
      selectedScheme,
      selectedCycle,
      schemeOptions,
      cycleOptions,
    } = this.state;

    return (
      <div className="page-content">
        <MetaTags>
          <title>Certificates</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title="Labs"
            breadcrumbItem="Certificate of Participation"
          />
          <div style={styles.tableNote}>
            Once participation is approved after payment verification, the
            Certificate of Participation (COP) will appear in the table for the
            respective scheme. The QR code on the certificate can be scanned to
            instantly verify its authenticity online.
          </div>

          {isLoading ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
            </div>
          ) : (
            <div style={styles.card}>
              {/* Step indicator */}
              {this.renderSteps()}

              {/* Filter dropdowns — 3-column grid */}
              <div style={styles.filterRow}>
                {/* Scheme */}
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>Scheme</label>
                  <select
                    style={styles.filterSelect}
                    value={selectedScheme}
                    onChange={this.handleSchemeChange}
                  >
                    <option value="">Select Scheme</option>
                    {schemeOptions.map(s => (
                      <option key={s.scheme_id} value={s.scheme_id}>
                        {s.scheme_name}
                      </option>
                    ))}
                  </select>
                  <span style={styles.chevron}>▾</span>
                </div>

                {/* Cycle */}
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>Cycle</label>
                  <select
                    style={
                      selectedScheme
                        ? styles.filterSelect
                        : styles.filterSelectDisabled
                    }
                    value={selectedCycle}
                    onChange={this.handleCycleChange}
                    disabled={!selectedScheme}
                  >
                    <option value="">Select Cycle</option>
                    {cycleOptions.map(c => (
                      <option key={c.cycle_id} value={c.cycle_id}>
                        Cycle {c.cycle_no}
                      </option>
                    ))}
                  </select>
                  <span style={styles.chevron}>▾</span>
                </div>

                {/* Empty 3rd col */}
                <div />
              </div>

              {/* Result table */}
              {this.renderTable()}
            </div>
          )}
        </Container>
      </div>
    );
  }
}

CertificatePage.propTypes = {
  gethomedata: PropTypes.func.isRequired,
  home: PropTypes.shape({
    purchased_schemes: PropTypes.array,
    payment_details: PropTypes.shape({
      payments: PropTypes.array,
    }),
    participant_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(state => ({ home: state.home.home }), { gethomedata })(
  withRouter(CertificatePage)
);
